var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Ayuda","storeName":"Helps","labelAddNew":"Agregar","canAdd":true,"canEdit":true,"canDelete":true,"sortable":"","next-link":"/admin/faqs","breadcrumbs":[
      {
        text: 'Información y soporte',
        disabled: false,
        href: '/admin/helps'
      },
      {
        text: 'Ayuda',
        disabled: false,
        href: '#'
      },
      
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }